import React, { VoidFunctionComponent } from "react";

interface Props {
    count: string;
    totalCount: string;
    reviewsProgression?: boolean
}

export const RatingBar: VoidFunctionComponent<Props> = ({ count, totalCount, reviewsProgression }) => {
    const dontHaveTotalCount = totalCount === '0';
    const filledBarWidth = dontHaveTotalCount
        ? '0%'
        : `${(parseInt(count) / parseInt(totalCount)) * 100}%`;
    const emptyBarWidth = dontHaveTotalCount
        ? '100%'
        : `${((parseInt(totalCount) - parseInt(count)) / parseInt(totalCount)) * 100}%`;
    return (
        <div className={`bar ${reviewsProgression ? 'reviews-progression' : ''}`}>
            <div
                className='filled-bar'
                style={{
                    width: filledBarWidth,
                }}
            />
            <div
                className='empty-bar'
                style={{
                    width: emptyBarWidth,
                }}
            />
        </div>
    );
};